/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react'
import FormCreator from '../../../components/FinalForms/FormCreator'
import Buttons from '../../../components/ui/button/Buttons'
import SkillCategoryDataFields from './SkillCategoryList.Data';
import ToastService from '../../../services/toastService/ToastService';
import { useEffect } from 'react';
import { useAddEditSkillCategoriesMutation, useLazyGetSkillCategoriesByIdQuery } from '../../../app/services/skillCategoriesAPI';
import { onResetForm } from '../../../utils/FormFields/ResetForm/handleResetForm';
import { securityKey } from '../../../data/SecurityKey';
import { hasFunctionalPermission } from '../../../utils/authorizeNavigation/authorizeNavigation';

const AddSkillCategory = (props) => {
  const ref = useRef();
  const [skillCategoriesData, setSkillCategoriesData] = useState(SkillCategoryDataFields);
  const skillCategoriesId = props.initData?.skillCategoriesId;
  const [isButtonDisable, setIsButtonDisable] = useState(false);
  const [addEditSkillCategories,{ isLoading: isAddEditSkillCategoriesLoading,isSuccess: isAddEditSkillCategoriesSuccess,data: AddEditSkillCategoriesData,}] = useAddEditSkillCategoriesMutation();
  const [getSkillCategoriesById,{isFetching: isGetSkillCategoriesByIdFetching,isSuccess: isGetSkillCategoriesByIdSuccess,data: isGetSkillCategoriesByIdData,}] = useLazyGetSkillCategoriesByIdQuery();
  const hasAddPermission = hasFunctionalPermission(securityKey.ADDSKILL);
  const hasEditPermission = hasFunctionalPermission(securityKey.EDITSKILL);


  const { formSetting } = SkillCategoryDataFields;

  useEffect(() => {
    if (!props.isEdit) {
        if (hasAddPermission && hasAddPermission.hasAccess === true) {
            formSetting.isViewOnly = false;
            setIsButtonDisable(false);
        }
    }
    else if (props.isEdit) {
        if (hasEditPermission.isViewOnly === true) {
            formSetting.isViewOnly = true;
            setIsButtonDisable(true)
        }
    }
}, [hasAddPermission, hasEditPermission, formSetting.isViewOnly]);
  useEffect(() => {
    if (skillCategoriesId && props.isEdit) {
      getSkillCategoriesById(skillCategoriesId);
    }
  }, [skillCategoriesId, props.isEdit]);

  useEffect(() => {
    if (!isGetSkillCategoriesByIdFetching &&isGetSkillCategoriesByIdSuccess &&isGetSkillCategoriesByIdData) {
      if (isGetSkillCategoriesByIdData) {
        let formData = { ...skillCategoriesData };
        formData.initialState = {
          skillCategoriesId: isGetSkillCategoriesByIdData.skillCategoriesId,
          skillCategoriesName : isGetSkillCategoriesByIdData.skillCategoriesName,
          description : isGetSkillCategoriesByIdData.description,
        };
        setSkillCategoriesData(formData);
      }
    }
  }, [isGetSkillCategoriesByIdFetching,isGetSkillCategoriesByIdSuccess,isGetSkillCategoriesByIdData,]);

  useEffect(() => {
    if (isAddEditSkillCategoriesSuccess && AddEditSkillCategoriesData) {
      if (AddEditSkillCategoriesData.errorMessage.includes("exists")) {
        ToastService.warning(AddEditSkillCategoriesData.errorMessage);
        return;
      }
      props.onSuccess();
      onResetData();
      ToastService.success(AddEditSkillCategoriesData.errorMessage);
    }
  }, [isAddEditSkillCategoriesSuccess, AddEditSkillCategoriesData]);

  useEffect(() => {
    if (props.isModelOpen && !props.isEdit) {
      let formData = { ...SkillCategoryDataFields };
      onResetForm(formData, setSkillCategoriesData, null);
    }
  }, [props.isModelOpen]);

  const onResetData = () => {
    let formData = { ...SkillCategoryDataFields };
    onResetForm(formData, setSkillCategoriesData, null);
    props.onClose();
  };

  const handleAdd = () => {
    const formData = ref.current?.getFormData();
    if (formData) {
      const requestData = {
        skillCategoriesId: skillCategoriesId || 0,
        skillCategoriesName: formData.skillCategoriesName,
        description: formData.description
      };
      addEditSkillCategories(requestData);
    }
  };

  return (
    <>
      <div className="skill-add-sec">
        <form>
          <div className="row mt-2">
            <FormCreator
              config={skillCategoriesData}
              ref={ref}
              {...skillCategoriesData}
            />
          </div>
        </form>
        <div className="row">
          <div className="col-12">
            <div className="form-btn d-flex align-items-center justify-content-end mb-2">
            <Buttons
                buttonTypeClassName="dark-btn mr-5"
                onClick={onResetData}
                buttonText="Cancel"
              />
            <Buttons
                buttonTypeClassName="theme-btn"
                 onClick={handleAdd}
                buttonText={props.isEdit ? "Update" : "Save"}
                 isLoading={isAddEditSkillCategoriesLoading}
                 isDisable={isButtonDisable}
              />              
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default AddSkillCategory
